import initialState from '../store/initialState'
import feedbackTypes from '../constants/feedbackTypes'

export default function feedbackReducer(state = initialState.feedback, action) {
  switch (action.type) {

    case feedbackTypes.set_errors: {
      return {
        ...state,
        errors: action.payload
      }
    }

    // Questions
    case feedbackTypes.get_questions.request: {
      return {
        ...state,
        fetching_questions: true,
        fetched_questions: false,
        errors: []
      }
    }

    case feedbackTypes.get_questions.success: {
      return {
        ...state,
        fetching_questions: false,
        fetched_questions: true,
        questions: action.payload.questions,
      }
    }

    case feedbackTypes.get_questions.failure: {
      return {
        ...state,
        fetching_questions: false,
        fetched_questions: false,
        errors: action.payload
      }
    }


    // GET
    case feedbackTypes.get.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: []
      }
    }

    case feedbackTypes.get.success: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        feedback: action.payload,
      }
    }

    case feedbackTypes.get.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }
    }

    // INDEX
    case feedbackTypes.index.request: {
      return {
        ...state,
        fetching_index: true,
        fetched_index: false,
        errors: []
      }
    }

    case feedbackTypes.index.success: {
      if (action.payload.serial && state.serial && action.payload.serial < state.serial) {
        // ignore
        // console.log('index request ignored; consequent request already served')
        return {
          ...state
        }
      }
      return {
        ...state,
        fetching_index: false,
        fetched_index: true,
        items: action.payload.feedbacks,
        pagination: action.payload.pagination,
        totals: action.payload.totals,
        serial: action.payload.serial || 0,
      }
    }

    case feedbackTypes.index.failure: {
      return {
        ...state,
        fetching_index: false,
        fetched_index: false,
        errors: action.payload
      }
    }

    // set status
    case feedbackTypes.mark_read.request:
    case feedbackTypes.mark_unread.request:
    case feedbackTypes.mark_resolved.request:{
      return {
        ...state,
        setting: true,
        set: false,
        errors: []
      };
    }

    case feedbackTypes.mark_read.success:
    case feedbackTypes.mark_unread.success:
    case feedbackTypes.mark_resolved.success:{
      return {
        ...state,
        setting: false,
        set: true,
        items: action.payload.feedbacks,
        totals: action.payload.totals,
        pagination: action.payload.pagination
      };
    }

    case feedbackTypes.mark_read.failure:
    case feedbackTypes.mark_unread.failure:
    case feedbackTypes.mark_resolved.failure:{
      return {
        ...state,
        setting: false,
        set: false,
        errors: action.payload
      }
    }


    default: {
      return {...state};
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/feedbackReducer.js